import styled from 'styled-components'

export const AuthorWrap = styled.div``;

export const AuthorImg = styled.figure`
    margin-bottom: 19px;
	display: flex;
    justify-content: center;
    img{
        border-radius: 50%;
    }
`;

export const AuthorName = styled.h5`
    font-size: 12px;
    margin-bottom: 8px;
`;

export const AuthorTagline = styled.p`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 16px
`;